document.querySelectorAll('.hacklabr-posts-grid-block--slider').forEach((container) => {
    const params = JSON.parse(container.querySelector('script').innerHTML);

    const swiper = hl_createSwiper(container.querySelector('.swiper'), {
        ...params,
    });
});

document.addEventListener('click', async (e) => {
    const link = e.target.closest('.pagination[data-rest-url] [data-page]');
    if (!link) return;

    const nav = link.closest('.pagination[data-rest-url]');
    if (!nav) return;

    e.preventDefault();

    const restUrl = nav.dataset.restUrl;
    const attributes = nav.dataset.attributes;
    const page = link.dataset.page;
    const currentPage = parseInt(nav.dataset.currentPage);

    if (page === currentPage.toString()) return;

    const grid = nav.parentElement.querySelector('.hacklabr-posts-grid-block');

    nav.dataset.currentPage = page;

    grid.style.opacity = '0.4';
    grid.style.pointerEvents = 'none';

    try {
        const url = `${restUrl}?page=${page}&attributes=${encodeURIComponent(attributes)}`;
        const res = await fetch(url);
        const data = await res.json();

        if (data.html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.html, 'text/html');

            const newGrid = doc.querySelector('.hacklabr-posts-grid-block');
            const newNav = doc.querySelector('.pagination');

            if (newGrid) {
                grid.replaceWith(newGrid);
            }

            if (newNav) {
                nav.replaceWith(newNav);
            } else {
                nav.remove();
            }
        }
    } catch (err) {
        nav.dataset.currentPage = currentPage.toString();
    }
});
